export const trackingId = 'UA-141128868-1';

export const DEFAULT_CONFIG = {
  debug: false,
  gaOptions: {
    cookieDomain: 'none',
  },
};
